
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ColoredDot } from "../Components/ColoredDot.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function ProblemReportStateIndicator(props) {
    let elems;
    const t = useTranslation()[0];
    let patternInput_1;
    const matchValue = props.State;
    patternInput_1 = ((matchValue.tag === 1) ? ["green", t("tool.problem_report_state_solved"), "solved"] : ((matchValue.tag === 2) ? ["grey", t("tool.problem_report_state_deferred"), "deferred"] : ["orange", t("tool.problem_report_state_open"), "open"]));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2"])], ["data-test-id", "problem-report-state-" + patternInput_1[2]], (elems = [createElement(ColoredDot, {
        Color: patternInput_1[0],
    }), reactElement("span", {
        children: patternInput_1[1],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

